import { useCallback } from 'react';
import {
  editOfferAffise,
  editBoardField,
  postCapAffise,
  getStatus,
} from "../utils/ApiCall";

/**
 * Custom hook for Master Performance board editing logic
 * @param {Object} state - Current board state
 * @param {Function} updateState - Function to update state
 * @param {string} pathname - Current pathname for API calls
 * @returns {Object} Object with edit handlers
 */
export const useMasterPerformanceEdit = (state, updateState, pathname) => {
  
  /**
   * Handles edit response changes for different fields
   */
  const handleEditResponseChange = useCallback(async (newValue, rowID, field) => {
    let status;
    if (field !== "offerStatus") {
      status = await getStatus(rowID, "master-performance");
    } else {
      status = newValue;
    }

    const updateStateByStatus = (stateName) => {
      return state[stateName].map((row) => {
        if (+row.id === +rowID) {
          return { ...row, [`${field}`]: newValue };
        }
        return row;
      });
    };

    let updates = {};
    if (status === "NOT PROFITABLE") {
      updates = { notProfitable: updateStateByStatus("notProfitable") };
    } else if (status === "INACTIVE") {
      updates = { inactive: updateStateByStatus("inactive") };
    } else {
      updates = { offerID: updateStateByStatus("offerID") };
    }
    updateState(updates);
  }, [state, updateState]);

  /**
   * Controls edit operations for different field types
   */
  const controlEdit = useCallback(async (params) => {
    let ids =
      state.selectionRow.length !== 0 ? state.selectionRow : [params.id];

    switch (params.field) {
      case "payoutAceptado":
        await editBoardField(
          "/master-performance",
          ids,
          params.field,
          state.payoutAceptado
        );
        break;
      case "estimadoCapMensual":
        await editBoardField(
          "/master-performance",
          ids,
          params.field,
          state.capMensual
        );
        break;
      case "cap":
        if (params.row.timeframe) {
          await postCapAffise(
            state.cap,
            params.row.timeframe,
            [],
            params.row.offerID,
            pathname.slice(1)
          );
        }
        break;
      case "revenueMAnunciante":
        const dataOffer = {
          revenueMonedaAnunciante: state.revenueMonedaAnunciante,
          id: params.row.offerID,
        };
        await editOfferAffise(dataOffer);
        break;
      default:
        break;
    }
  }, [state.selectionRow, state.payoutAceptado, state.capMensual, state.cap, state.revenueMonedaAnunciante, pathname]);

  /**
   * Updates board with new data
   */
  const updateBoard = useCallback((newData) => {
    // No need to track updateRows in state since it causes loops
    console.log('Board updated with:', newData);
  }, []);

  return {
    handleEditResponseChange,
    controlEdit,
    updateBoard
  };
};